module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Senior-01Champion_S01.101629de.png";